/** Figma-style cursor shared by layout and equipment corner rotation zones. */
export const ROTATE_CURSOR = (() => {
  const svg = `<svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.92719 9.91431H14.0064C18.4684 9.91431 22.0856 13.5315 22.0856 17.9935V26.0727" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.91433 5.92725L5.92719 10.0193L9.91433 14.1114" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.0985 22.0857L22.0857 26.0728L26.0728 22.0857" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 12 12, auto`;
})();

export const ROTATION_ZONE_SIZE = 24;

export function snapRotationTo45(angle: number): number {
  const snapped = Math.round(angle / 45) * 45;
  return ((snapped % 360) + 360) % 360;
}
